<script lang="ts" setup>
import { ApiInsuranceCategory } from '~~/server/api/insurance/category'

const route = useRoute()

const { data: page, redirect } = await useFetchWithRedirect<ApiInsuranceCategory>('/api/insurance/category', { route }, {
    params: {
        slug: route.params.id,
        t: route.query.t || '',
    },
})

if(redirect && !redirect?.error) {
    navigateTo(redirect.data.url, redirect.data.options)
}

const breadcrumbs = computed<BreadcrumbsLink[]>(() => {
    if (page.value?.data.breadcrumbs.length === 0) return []

    return [
        {
            name: (page.value?.data.breadcrumbs?.[0]?.name ?? '') as string,
            slug: useNamedRoutes({ name: 'insurance-categories' }),
        },
    ]
})

// Schema.org
useSchemaOrg([
    defineWebPage({
        name: page.value?.data.title,
        keywords: page.value?.data.meta.meta_keywords ? [page.value.data.meta.meta_keywords] : [],
    }),
])

// Page meta
usePageMeta({
    meta: page.value?.data.meta,
    title: page.value?.data.title,
})
</script>
<template>
  <article v-if="page">
    <ContainerFluid>
      <Breadcrumbs
        :current="page.data.title"
        :links="breadcrumbs"
      />
    </ContainerFluid>
    <PageHeader
      class="mb-12"
      :headline="page.data.headline"
      :title="page.data.title"
      :cta="page.data.headline?.cta"
      :perex="page.data.description"
    />
    <div class="content-visibility-auto">
      <ContainerFluid class="mt-20">
        <WidgetProducts
          v-if="page.data.bestsellers"
          :bestsellers="page.data.bestsellers"
          :products="page.data.products"
          :other-products="page.data.other_products"
          heading-level="h2"
          class="mb-12 mb-md-20"
        />
        <LazyGallery
          v-if="page.data.gallery?.data[0]?.file?.path"
          class="mb-12 mb-md-30"
          :data="page.data.gallery"
          :extra="page.data.gallery?.data[0]?.title"
          :thumbnail="page.data.gallery.data[0].file.path"
          heading-level="h2"
        />
        <LazyVVideo
          v-if="page.data.video"
          heading-level="h2"
          class="mb-12 mb-md-20"
          :data="page.data.video"
        />
        <LazyBanner
          v-if="page.data.banner"
          :data="page.data.banner"
          heading-level="h2"
        >
          <template
            v-if="page.data.banner.tag.background && page.data.banner.tag.name"
            #tag
          >
            <Label
              :text-color="page.data.banner.tag.color"
              :label="page.data.banner.tag.name"
              :background-color="page.data.banner.tag.background"
            />
          </template>
        </LazyBanner>
        
        <div
          v-if="page.data.seo_article"
          class="mt-12 mt-md-20"
        >
          <LazySeoArticle :content="page.data.seo_article" />
        </div>

        <div class="mt-12 mt-md-20 pt-12 pt-md-20 border-top">
          <LazyWidgetHelpdeskExt />
        </div>
      </ContainerFluid>
    </div>
  </article>
</template>
